import React from 'react';
import { Route } from 'react-router-dom';
import { withSuspense } from '../routeHelpers';
import * as Pages from '../lazyPages/mobile';

export function getMobileRoutes() {
  return (
    <>
      <Route path="/mobile/settings" element={withSuspense(<Pages.MobileAppSettingsPage />)} />
    </>
  );
}
